export const Z_BUY_NOW_PAY_LATER_PAYMENT_KEY = 'spay_zps_bnpl';

export const BnplSlotName = {
  /** Used for both recommended badge (when offered) and disabled text (when not available) */
  optionUnderLabel: `slot_option_${Z_BUY_NOW_PAY_LATER_PAYMENT_KEY}_under-label`,
  optionSelectedUnderLabel: `slot_option_selected_${Z_BUY_NOW_PAY_LATER_PAYMENT_KEY}_under-label`,
  dynamicAreaPaymentOptions: `slot_dynamic_area_payment_options_${Z_BUY_NOW_PAY_LATER_PAYMENT_KEY}`,
} as const;

export enum MarketGroup {
  DACH = 'DACH',
  PL = 'PL',
  Nordics = 'Nordics',
  Benelux = 'Benelux',
}

const MARKET_GROUP_CONFIG: Record<string, MarketGroup> = {
  DE: MarketGroup.DACH,
  AT: MarketGroup.DACH,
  CH: MarketGroup.DACH,
  PL: MarketGroup.PL,
  DK: MarketGroup.Nordics,
  SE: MarketGroup.Nordics,
  FI: MarketGroup.Nordics,
  NO: MarketGroup.Nordics,
  NL: MarketGroup.Benelux,
  BE: MarketGroup.Benelux,
};

export const getMarketGroup = (countryCode: string): MarketGroup | undefined =>
  MARKET_GROUP_CONFIG[countryCode];
